<template>
    <div v-show="visible">
        <el-dialog title="查看附件" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="500px">    
            <div>
                <div v-if="form.image1Url != null && form.image1Url != ''">
                    <el-popover
                        placement="right"
                        title=""
                        trigger="hover">
                        <img :src="form.image1Url" lazy="loading"
                            style="max-height:500px; max-width:700px"/>
                        <img slot="reference" :src="form.image1Url"  lazy="loading" :alt="form.image1Url" style="max-height: 200px;max-width: 480px">
                    </el-popover>
                </div>

                 <div v-if="form.image2Url != null && form.image2Url != ''">
                    <el-popover
                        placement="right"
                        title=""
                        trigger="hover">
                        <img :src="form.image2Url" lazy="loading"
                            style="max-height:500px; max-width:700px"/>
                        <img slot="reference" :src="form.image2Url"  lazy="loading" :alt="form.image2Url" style="max-height: 200px;max-width: 480px">
                    </el-popover>
                </div>

                 <div v-if="form.image3Url != null && form.image3Url != ''">
                    <el-popover
                        placement="right"
                        title=""
                        trigger="hover">
                        <img :src="form.image3Url" lazy="loading"
                            style="max-height:500px; max-width:700px"/>
                        <img slot="reference" :src="form.image3Url"  lazy="loading" :alt="form.image3Url" style="max-height: 200px;max-width: 480px">
                    </el-popover>
                </div>
            </div> 

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import {banBackSpace} from '../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                form:{
                    deptId:"",
                    image1Url:"",
                    image2Url:"",
                    image3Url:""
                },
            }
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(data){
                this.visible=true;
                this.form.image1Url=data.image1Url;
                this.form.image2Url=data.image2Url;
                this.form.image3Url=data.image3Url;
                console.log(this.form.image3Url);
            },
            dialogClose(done){
                done();
                this.$reload;
            }
        }
    }

</script>

<style scoped>
   .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }  
</style>


// WEBPACK FOOTER //
// src/components/page/count/LevaeFile.vue